export const translationList = [
  {
    name: "English",
    value: "en",
  },
  {
    name: "繁体中文",
    value: "cht",
  },
  {
    name: "简体中文",
    value: "zh",
    lang: "zh-CN",
  },
  {
    name: "한국어",
    value: "kor",
  },
  {
    name: "日本語",
    value: "jp",
  },
  {
    name: "español",
    value: "spa",
  },
  {
    name: "italiano",
    value: "it",
  },
  {
    name: "português",
    value: "pt",
  },
  {
    name: "français",
    value: "fra",
  },
  {
    name: "العربية",
    value: "ara",
  },
  {
    name: "ไทย",
    value: "th",
  },
  {
    name: "Deutsch",
    value: "de",
  },
  {
    name: "Ελληνικά",
    value: "el",
  },
  {
    name: "Nederlands",
    value: "Polskie",
  },
  {
    name: "български",
    value: "bul",
  },
  {
    name: "Eestlane",
    value: "est",
  },
  {
    name: "dansk",
    value: "dan",
  },
  {
    name: "Suomalainen",
    value: "fin",
  },
  {
    name: "čeština",
    value: "cs",
  },
  {
    name: "Română",
    value: "rom",
  },
  {
    name: "Slovenščina",
    value: "slo",
  },
  {
    name: "svenska",
    value: "swe",
  },
  {
    name: "Magyar",
    value: "hu",
  },
  {
    name: "Tiếng Việt",
    value: "vie",
  },
];
